module.exports = {"433125104":"普戎镇","433125108":"复兴镇","433125109":"迁陵镇","433125110":"清水坪镇","433125111":"比耳镇","433125112":"毛沟镇","433125113":"水田河镇","433125114":"葫芦镇","433125115":"碗米坡镇","433125116":"吕洞山镇","433125217":"阳朝乡","433125218":"长潭河乡","433125401":"扁朝牧场","433125403":"白云山农垦场","433125404":"钟灵山工业园","433125405":"麻风村"}


//////////////////
// WEBPACK FOOTER
// ./src/town/433125.json
// module id = 1770
// module chunks = 0